export default {

  myFilter (val) {
    console.log(val)
    return 'defaultData'
  }
}



// WEBPACK FOOTER //
// ./src/filters/allFilters/myFilter.js